import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { ArrowRight } from 'lucide-react';

export const FinalCTA = () => {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="section-dark py-24 md:py-32 relative overflow-hidden"
    >
      {/* Background effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-r from-blue-500/20 to-purple-500/20 rounded-full blur-[128px]"></div>
      </div>

      <div className="max-w-4xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-6">
            Start Building Backlinks the Right Way.{' '}
            <span className="gradient-text">Today.</span>
          </h2>
          <p className="text-white/70 text-lg mb-10 max-w-2xl mx-auto">
            Join SEO professionals, marketers, and founders who stopped guessing and started winning with Searchefy. One payment. Lifetime access. Continuous updates.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
            <a
              href="https://checkout.dodopayments.com/buy/pdt_0Nc1Sd7RjzAPh38CNHxE9?quantity=1"
              data-testid="final-cta-button"
              className="btn-primary text-lg px-10 py-5 flex items-center gap-2 animate-pulse-glow"
            >
              Get Lifetime Access — $9
              <ArrowRight size={20} />
            </a>
          </div>

          <p className="text-white/50 text-sm">
            No subscription. No renewal. All future updates included.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
